import ModalPauseResume from './ModalPauseResume'

export default ModalPauseResume
// eslint-disable-next-line import/export
export * from './ModalPauseResume'
